<template>
    <div>
        <!-- Container parent de la modal des codex -->
        <div v-if="list_codex.chatbot" id="container-modal-codex-dialogue" class="modal-custom">
            <!-- Afficher le codex chatbot -->
            <div
                v-for="codex_chabot in list_codex.chatbot"
                :key="codex_chabot.id_codex"
                :id="'texte-modal-' + codex_chabot.id_codex"
                class="container-texte-modal"
                v-html="codex_chabot.texte"
            ></div>
    
            <!-- Container du bouton pour fermer la modal codex chatbot -->
            <div class="container-fermeture-modal" data-id-modal="container-modal-codex-dialogue">
                <input id="icon-fermeture-modal-codex" type="image" src="images/pictos/icon-fermeture.svg" />
            </div>
        </div>
    
        <!-- Container parent des codex de type CTA -->
        <div v-if="list_codex.cta" id="container-button-codex-dialogue" class="container-button">
            <!-- Afficher le codex CTA -->
            <div
                v-for="codex_cta in list_codex.cta"
                :key="codex_cta.id_codex"
                :id="'texte-modal-' + codex_cta.id_codex"
                class="container-button-cta"
            >
            <a
                :id="'texte-button-' + codex_cta.id_codex"
                :href="codex_cta.url"
                class="cta-button"
                target="_blank"
            >
                <!-- Texte du codex cta généré avec v-html -->
                <button v-html="codex_cta.texte"></button>
            </a>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'ListCodexComponent',
        props: {
            list_codex: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {};
        },
    };
</script>